import { motion } from "framer-motion"; // For modal entrance animations
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { Box, Typography, useMediaQuery } from "@mui/material";
import HtmlContent from "../../components/html-content/HtmlContent";
import { Celebrations } from "../../utility/interfaces/carePlanInterfaces";
import {
  getCelebrationImage,
  ConfettiTimed,
  ConfettiTimedMobile,
} from "./CelebrationCommon";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";

interface TrimesterCompletedProps {
  onClose: (celebration: Celebrations) => void;
  celebration: Celebrations;
}

export const TrimesterCompleted: React.FC<TrimesterCompletedProps> = ({
  onClose,
  celebration,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const preferredLanguage = useAppSelector(
    (state) => state.patientOnboardingStatus.preferredLanguage
  );
  return (
    <motion.div
      className="modal modal--first"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      {isMobile ? <ConfettiTimedMobile /> : <ConfettiTimed />}
      <div className="modal__image">
        <img
          src={getCelebrationImage(
            celebration.eventCode,
            preferredLanguage.toLowerCase()
          )}
          alt="Trimester Completed"
          className="trimesterCompleted"
        />
      </div>

      <Typography variant="body1" mb={3} className="celebration">
        <HtmlContent htmlString={celebration.content || "NA"} />
      </Typography>
      <Box sx={{ paddingTop: { xs: "30px", sm: "30px", md: "5px" } }}>
        <CustomButton
          onClick={() => onClose(celebration)}
          variant="contained"
          text={t("noShowAppointment.closeButton")}
        />
      </Box>
    </motion.div>
  );
};
